import { useEffect, useState } from "react";


type ScriptStatus = "loading" | "ready" | "error";

export default function useScript(src: string, attrs?: Record<string, string>) {
	const [status, setStatus] = useState<ScriptStatus>(() => {
		const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
		return existing ? (existing.dataset.status as ScriptStatus ?? "loading") : "loading";
	});

	useEffect(() => {
		let script = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
		if (!script) {
			script = document.createElement("script");
			script.src = src;
			script.async = true;
			script.dataset.status = "loading";
			if (attrs) Object.entries(attrs).forEach(([k, v]) => script!.setAttribute(k, v));
			document.body.appendChild(script);
		}

		const currentStatus = script.dataset.status as ScriptStatus | undefined;
		if (currentStatus === "ready" || currentStatus === "error") {
			setStatus(currentStatus);
			return;
		}

		const onLoad = () => { script!.dataset.status = "ready"; setStatus("ready"); };
		const onError = () => { script!.dataset.status = "error"; setStatus("error"); };

		script.addEventListener("load", onLoad);
		script.addEventListener("error", onError);

		return () => {
			script!.removeEventListener("load", onLoad);
			script!.removeEventListener("error", onError);
		};
	}, [src]);

	return status;
};